// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"92bb0836","667":"bb9ebafb","977":"8f8c97fe"}[chunkId] + ".chunk.js";
};